const znJSON = {
  'Accent Sidebar': '口音側邊欄',
  'Accent Header': '口音標題'
};

export default znJSON;
